// extracted by mini-css-extract-plugin
export default {"weapon":"WeaponCard_weapon__y0a4N","capa":"WeaponCard_capa__fEqdS","titulo":"WeaponCard_titulo__QeOV6"};